var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMetamask(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "MetaMask_Fox / 24",
    clipPath: "url(#clip0_730_25747)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M22.5381 1.12286L13.4102 7.9023L15.0981 3.90252L22.5381 1.12286Z",
    fill: "#E2761B",
    stroke: "#E2761B",
    strokeWidth: 0.103373,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M1.4652 1.12286L10.5197 7.96652L8.91433 3.90252L1.4652 1.12286ZM19.2532 16.8376L16.8221 20.5621L22.0237 21.9933L23.519 16.9201L19.2532 16.8376ZM0.501953 16.9201L1.98811 21.9933L7.18965 20.5621L4.7586 16.8376L0.501953 16.9201Z",
    fill: "#E4761B",
    stroke: "#E4761B",
    strokeWidth: 0.103373,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M6.89673 10.5443L5.44727 12.7369L10.6121 12.9662L10.4286 7.41608L6.89673 10.5443ZM17.1072 10.5443L13.5294 7.35187L13.4101 12.9662L18.5658 12.7369L17.1072 10.5443ZM7.19029 20.5621L10.291 19.0485L7.61228 16.9568L7.19029 20.5621ZM13.7129 19.0485L16.8228 20.5621L16.3916 16.9568L13.7129 19.0485Z",
    fill: "#E4761B",
    stroke: "#E4761B",
    strokeWidth: 0.103373,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M16.8229 20.5621L13.713 19.0485L13.9607 21.0759L13.9332 21.929L16.8229 20.5621ZM7.19043 20.5621L10.0802 21.929L10.0618 21.0759L10.2912 19.0485L7.19043 20.5621Z",
    fill: "#D7C1B3",
    stroke: "#D7C1B3",
    strokeWidth: 0.103373,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M10.1261 15.6174L7.53906 14.856L9.36465 14.0212L10.1261 15.6174ZM13.8782 15.6174L14.6396 14.0212L16.4743 14.856L13.8782 15.6174Z",
    fill: "#161616",
    stroke: "#233447",
    strokeWidth: 0.103373,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M7.18985 20.5621L7.63019 16.8376L4.75879 16.9201L7.18985 20.5621ZM16.382 16.8376L16.8223 20.5621L19.2534 16.9201L16.382 16.8376ZM18.5654 12.7369L13.4097 12.9662L13.8867 15.6174L14.6481 14.0212L16.4829 14.856L18.5654 12.7369ZM7.53845 14.856L9.37321 14.0212L10.1255 15.6174L10.6117 12.9662L5.44682 12.7369L7.53845 14.856Z",
    fill: "#CD6116",
    stroke: "#CD6116",
    strokeWidth: 0.103373,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M5.44727 12.7369L7.61228 16.9568L7.53889 14.856L5.44727 12.7369ZM16.4833 14.856L16.3916 16.9568L18.5658 12.7369L16.4833 14.856ZM10.6121 12.9662L10.1259 15.6174L10.7314 18.7457L10.869 14.6267L10.6121 12.9662ZM13.4101 12.9662L13.1624 14.6175L13.2725 18.7457L13.8872 15.6174L13.4101 12.9662Z",
    fill: "#E4751F",
    stroke: "#E4751F",
    strokeWidth: 0.103373,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M13.8873 15.6174L13.2727 18.7457L13.713 19.0484L16.3918 16.9568L16.4835 14.856L13.8873 15.6174ZM7.53906 14.856L7.61245 16.9568L10.2912 19.0484L10.7315 18.7457L10.1261 15.6174L7.53906 14.856Z",
    fill: "#F6851B",
    stroke: "#F6851B",
    strokeWidth: 0.103373,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M13.9332 21.929L13.9607 21.0759L13.7313 20.874H10.2728L10.0618 21.0759L10.0802 21.929L7.19043 20.5621L8.19955 21.3878L10.2453 22.8097H13.7589L15.8138 21.3878L16.8229 20.5621L13.9332 21.929Z",
    fill: "#C0AD9E",
    stroke: "#C0AD9E",
    strokeWidth: 0.103373,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M13.7127 19.0485L13.2724 18.7457H10.7312L10.2909 19.0485L10.0615 21.0759L10.2725 20.874H13.731L13.9604 21.0759L13.7127 19.0485Z",
    fill: "#161616",
    stroke: "#161616",
    strokeWidth: 0.103373,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M22.923 8.34264L23.7028 4.59973L22.5377 1.12286L13.7125 7.67296L17.1068 10.5444L21.9047 11.9479L22.9689 10.7095L22.5102 10.3792L23.2441 9.70954L22.6753 9.2692L23.4092 8.7096L22.923 8.34264ZM0.30957 4.59973L1.08934 8.34264L0.593958 8.7096L1.32786 9.2692L0.76826 9.70954L1.50216 10.3792L1.04347 10.7095L2.09846 11.9479L6.89636 10.5444L10.2907 7.67296L1.46547 1.12286L0.30957 4.59973Z",
    fill: "#763D16",
    stroke: "#763D16",
    strokeWidth: 0.103373,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M21.9044 11.9479L17.1065 10.5444L18.5652 12.7369L16.391 16.9568L19.2532 16.9201H23.519L21.9044 11.9479ZM6.89609 10.5444L2.09819 11.9479L0.501953 16.9201H4.7586L7.61165 16.9568L5.44663 12.7369L6.89609 10.5444ZM13.4095 12.9662L13.7122 7.67296L15.1066 3.90253H8.91433L10.2904 7.67296L10.6115 12.9662L10.7216 14.6359L10.7307 18.7457H13.2719L13.2902 14.6359L13.4095 12.9662Z",
    fill: "#F6851B",
    stroke: "#F6851B",
    strokeWidth: 0.103373,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_730_25747"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.00390625)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMetamask);
export default __webpack_public_path__ + "static/media/metamask.b640f51486ea4ab0a5f501a067abe952.svg";
export { ForwardRef as ReactComponent };